import request from './request';

const isFormData = (data) => data instanceof FormData;

/**
 * Same pattern as banner service: when sending FormData, do not set Content-Type
 * so axios sets multipart/form-data with the correct boundary.
 */
const formDataConfig = { headers: { 'Content-Type': undefined } };

const blogService = {
  getPaginate: (params) => request.get('dashboard/admin/blogs/paginate', { params }),
  getAll: (params) => request.get('dashboard/admin/blogs', { params }),
  getById: (id) => request.get(`dashboard/admin/blogs/${id}`),
  create: (data) => {
    if (isFormData(data)) {
      return request.post('dashboard/admin/blogs', data, formDataConfig);
    }
    return request.post('dashboard/admin/blogs', data);
  },
  update: (id, data) => {
    if (isFormData(data)) {
      return request.put(`dashboard/admin/blogs/${id}`, data, formDataConfig);
    }
    return request.put(`dashboard/admin/blogs/${id}`, data);
  },
  delete: ({ ids }) =>
    request.delete('dashboard/admin/blogs/delete', { data: { ids } }),
  deleteById: (id) => request.delete(`dashboard/admin/blogs/${id}`),
  /** Toggle active — path param must be blog `uuid`, not MongoDB `_id` (per API spec). */
  setActive: (blogUuid) =>
    request.post(`dashboard/admin/blogs/${blogUuid}/active/status`),
  /** Publish — path param must be blog `uuid`, not MongoDB `_id`. */
  publish: (blogUuid) =>
    request.post(`dashboard/admin/blogs/${blogUuid}/publish`),
  dropAll: () => request.get(`dashboard/admin/blogs/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/blogs/restore/all`),
  /** Distinct categories in use, for a creatable dropdown. */
  getCategories: () => request.get('dashboard/admin/blogs/categories'),
  /** Distinct tags in use, for a creatable multi-select. */
  getTags: () => request.get('dashboard/admin/blogs/tags'),
  /** Upload one image, get back a URL to embed inside `content` (rich-text editor toolbar). */
  uploadImage: (data) =>
    request.post('dashboard/admin/blogs/upload-image', data, formDataConfig),
};

export default blogService;
